import React, { useCallback } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

const ConfirmUndo = ({
	title = 'Confirm',
	buttonTextConfirm = 'Confirm',
	buttonBsStyleConfirm = 'primary',
	buttonTextCancle = 'Cancel',
	buttonBsStyleCancel = 'default',
	onConfirm = () => {},
	onCancel = () => {},
	onClose = () => {},
	isOpen,
	children
}) => {
	const handleClose = useCallback(() => {
		onClose();
	}, [onClose]);

	const handleConfirm = useCallback(() => {
		onConfirm();
		handleClose();
	}, [onConfirm, handleClose]);

	const handleCancel = useCallback(() => {
		onCancel();
		handleClose();
	}, [onCancel, handleClose]);

	return (
		<>
			<Modal backdrop="static" show={isOpen} onHide={handleClose}>
				<Modal.Header>
					<Modal.Title>{title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>{children}</Modal.Body>
				<Modal.Footer>
					<Button bsStyle={buttonBsStyleCancel} onClick={handleCancel}>
						{buttonTextCancle}
					</Button>
					<Button bsStyle={buttonBsStyleConfirm} onClick={handleConfirm}>
						{buttonTextConfirm}
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default ConfirmUndo;
